import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function RedactIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M11.623 6.86 9.14 4.377M2 14l2.101-.233c.257-.029.385-.043.505-.082a1.2 1.2 0 0 0 .301-.145c.106-.07.197-.16.38-.343l8.199-8.2a1.756 1.756 0 0 0-2.484-2.483l-8.199 8.2c-.182.182-.274.273-.343.379q-.093.14-.145.3c-.039.12-.053.25-.082.506z" /></svg>
  );
}

export default RedactIcon;
